import { INavMenu, INavMenuItem } from "@types";
import React from "react";
import { Link } from "react-router-dom";
import * as S from "../../style/DesktopNavbar.styled";

interface NavbarMenuProps {
  pathname: string;
  navMenuItems: INavMenu | null;
  activeMenuItemPath: string;
  setActiveMenuItemPath: (path: string) => void;
  handleMenuHover: (item: INavMenuItem) => void;
}

const NavbarMenu: React.FC<NavbarMenuProps> = ({
  pathname,
  navMenuItems,
  activeMenuItemPath,
  setActiveMenuItemPath,
  handleMenuHover,
}) => {
  return (
    <S.Menu>
      {navMenuItems?.navbar?.map(
        (item) =>
          item.isAllow && (
            <S.MenuLink
              as={Link}
              to={item.to}
              key={item.text}
              onMouseEnter={() => handleMenuHover(item)}
              onClick={() => setActiveMenuItemPath(item.to)}
            >
              <S.StyledButton
                $activeitem={activeMenuItemPath.includes(item.to)}
                $pathname={pathname}
              >
                {item.icon}
                <span>{item.name}</span>
              </S.StyledButton>
            </S.MenuLink>
          )
      )}
    </S.Menu>
  );
};

export default NavbarMenu;
